import React, { memo, useEffect } from "react";
import CustomTabs from "components/common/tabs/CustomTabs";

import useSettings from "./useSettings";

import { useDispatch } from "react-redux";
import { setTitle } from "app/store/transmission/slice/transmissionSlice";
import { SETTINGS_TAB_VIEW_MAPPER } from "static/constants";

const Settings = (props) => {
  const { tabs, currentTab, onTabChange } = useSettings(props);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setTitle({ title: SETTINGS_TAB_VIEW_MAPPER[currentTab] }));
  }, [currentTab, dispatch]);

  return (
    <CustomTabs tabs={tabs} selectedTab={currentTab} onChange={onTabChange} />
  );
};

export default memo(Settings);
